import { createModel } from '@rematch/core';

import { RootModel } from '.';

interface State {
  title: string;
  slug: string;
  id: number;
  date_created: string;
  editor: string;
  is_open_list: boolean;
}

const initialState: State = {
  title: '',
  slug: '',
  id: 0,
  date_created: '',
  editor: '',
  is_open_list: false,
};

export const coverImages = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setNewArticle(
      state,
      payload: {
        title: string;
        slug: string;
        id: number;
        date_created: string;
        editor: string;
        is_open_list: boolean;
      },
    ) {
      return {
        title: payload.title,
        slug: payload.slug,
        id: payload.id,
        date_created: payload.date_created,
        editor: payload.editor,
        is_open_list: payload.is_open_list,
      };
    },
    clearArticle() {
      return initialState;
    },
  },
  effects: (dispatch) => ({}),
});
